import { apiYClickServicios } from './api';

// eslint-disable-next-line import/prefer-default-export
export const getReferenceColors = async () => {
  const result = await apiYClickServicios.get(`/v1/PartesTrabajo/vistaExtendida/coloresReferencia`);

  return result.data;
};